// 分组(岗位)关联指标
import http from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';

// 分页查询-xsh
export function getGroupKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/groupKpi/page',
        method: 'post',
        data
    });
};
// 导入-xsh
export function importGroupKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/groupKpi/import',
        method: 'post',
        data
    });
};
// 模板下载-xsh
export function downloadGroupKpiReportTemplate(data) {
    return http({
        url: apiCrmHost + '/goal/manage/groupKpi/file/download',
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
        utils.downloadStream(res, data.fileName);
    });
};
// 删除-xsh
export function deleteGroupKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/groupKpi/deleteBatch',
        method: 'post',
        data
    });
};
// 导出-xsh
export function exportGroupKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/groupKpi/export',
        method: 'post',
        data
    });
};
